import React from 'react';
import { EditIcon, BarChartIcon, FileTextIcon, BuildingIcon } from 'lucide-react';
import { ExchangeRateType } from '../CurrencyExchangeView';
interface ExchangeRateBadgeProps {
  type: ExchangeRateType;
  size?: 'sm' | 'md';
}
export function ExchangeRateBadge({
  type,
  size = 'md'
}: ExchangeRateBadgeProps) {
  const getTypeStyles = () => {
    switch (type) {
      case 'Spot':
        return {
          bg: 'bg-green-100',
          text: 'text-green-800',
          icon: <BarChartIcon className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} data-id="element-8404" />
        };
      case 'Contract':
        return {
          bg: 'bg-purple-100',
          text: 'text-purple-800',
          icon: <FileTextIcon className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} data-id="element-8405" />
        };
      case 'Corporate':
        return {
          bg: 'bg-blue-100',
          text: 'text-blue-800',
          icon: <BuildingIcon className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} data-id="element-8406" />
        };
      case 'Bank':
        return {
          bg: 'bg-orange-100',
          text: 'text-orange-800',
          icon: <div className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} data-id="element-8407" />
        };
      case 'Custom':
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          icon: <EditIcon className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} data-id="element-8408" />
        };
      default:
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          icon: null
        };
    }
  };
  const styles = getTypeStyles();
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-0.5 text-xs';
  return <span className={`inline-flex items-center ${sizeClasses} rounded-full font-medium ${styles.bg} ${styles.text}`} data-id="element-8409">
      {styles.icon}
      {type}
    </span>;
}